import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaCheckCircle } from "react-icons/fa";
import { FaSeedling, FaClipboardCheck, FaShieldAlt } from "react-icons/fa";
import { FaPlus } from "react-icons/fa";
import "../styles/values.css";

const services = [
  {
    title: "Nurturing",
    icon: <FaSeedling />,
    content:
      "We are committed to fostering an environment where innovation thrives, empowering entrepreneurs with the tools, resources, and support they need to create transformative solutions.",
  },
  {
    title: "Empowering",
    icon: <FaCheckCircle />,
    content:
      "Our focus is on empowering entrepreneurs to grow and scale their businesses through strategic support, capacity building, and fostering an entrepreneurial mindset that drives socio-economic development.      ",
  },
  {
    title: "Xenial Collaboration",
    icon: <FaClipboardCheck />,
    content:
      "We value collaboration and work with diverse stakeholders across sectors—public, private, academia, and development—to drive growth and create mutually beneficial partnerships that generate impact.      ",
  },
  {
    title: "Accelerate",
    icon: <FaShieldAlt />,
    content:
      "Through our programs, networks, and resources, we accelerate the growth of startups and SMEs, providing them with the necessary mentorship, investment opportunities, and expertise to navigate and thrive in competitive markets.",
  },
];

const ServicesSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="services-section">
      <motion.h2
        className="services-header"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <span className="bold">Core </span>
        <span className="highlight">Values</span>
      </motion.h2>

      <motion.p
        className="services-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.6 }}
      >
        Our N.E.X.A. values guide everything we do, representing the pillars
        upon which we build our programs, partnerships, and impact initiatives
        across Africa.
      </motion.p>

      <div className="values-container">
        <div className="values-accordion-wrapper">
          {services.map((service, index) => (
            <div
              className={`values-accordion-card ${
                activeIndex === index ? "active" : ""
              }`}
              key={index}
              onClick={() => toggleAccordion(index)}
            >
              <div className="values-accordion-header">
                <div className="values-icon-circle">{service.icon}</div>
                <h4>{service.title}</h4>
                <FaPlus
                  className={`plus ${activeIndex === index ? "rotate" : ""}`}
                />
              </div>

              <AnimatePresence initial={false}>
                {activeIndex === index && (
                  <motion.div
                    className="values-accordion-content"
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <p>{service.content}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesSection;
